import React, { useEffect, useState } from 'react';
import dashboards from './dashboards.json';
import './App.css';

export default function App() {
  const [user, setUser] = useState(null);
  const [selectedDept, setSelectedDept] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const netlifyIdentity = window.netlifyIdentity;

    if (netlifyIdentity) {
      // 1. Listen for initialization completion to capture URL tokens
      netlifyIdentity.on('init', (user) => {
        setUser(user);
      });

      // 2. Initialize the widget (automatically handles recovery_token & invite_token)
      netlifyIdentity.init();

      // 3. Set current user state
      setUser(netlifyIdentity.currentUser());

      // 4. Handle authentication events
      netlifyIdentity.on('login', (currentUser) => {
        setUser(currentUser);
        netlifyIdentity.close();
      });

      netlifyIdentity.on('logout', () => {
        setUser(null);
      });

      // 5. Open modal ONLY if token exists, without forcing 'login' tab
      const hash = window.location.hash;
      if (hash && (hash.includes('recovery_token') || hash.includes('invite_token'))) {
        netlifyIdentity.open(); // No 'login' argument here!
      }
    }
  }, []);

  const handleLogin = () => {
    if (window.netlifyIdentity) {
      window.netlifyIdentity.open('login');
    }
  };

  const handleLogout = () => {
    if (window.netlifyIdentity) {
      window.netlifyIdentity.logout();
    }
  };

  const departments = ['All', ...new Set(dashboards.map(d => d.department))];

  const filteredDashboards = dashboards.filter(dash => {
    const matchesDept = selectedDept === 'All' || dash.department === selectedDept;
    const matchesSearch = dash.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          dash.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesDept && matchesSearch;
  });

  if (!user) {
    return (
      <div className="login-container">
        <div className="login-card">
          <img src="/unichem-logo.png" alt="Unichem Ghana Group" className="brand-logo" />
          <h1>Unichem Management Portal</h1>
          <p>Please log in with authorized credentials to view central department dashboards.</p>
          <button className="btn-primary" onClick={handleLogin}>Log In</button>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-container">
      <header className="portal-header">
        <div className="header-brand">
          <img src="/unichem-logo.png" alt="Unichem Ghana Group" className="brand-logo-small" />
          <div>
            <h2>Unichem Management Hub</h2>
            <span className="user-badge">Logged in as: {user.email}</span>
          </div>
        </div>
        <button className="btn-secondary" onClick={handleLogout}>Log Out</button>
      </header>

      <div className="controls">
        <div className="tabs">
          {departments.map(dept => (
            <button
              key={dept}
              className={`tab-btn ${selectedDept === dept ? 'active' : ''}`}
              onClick={() => setSelectedDept(dept)}
            >
              {dept}
            </button>
          ))}
        </div>

        <input
          type="text"
          className="search-input"
          placeholder="Search dashboards..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="dashboard-grid">
        {filteredDashboards.map(dash => (
          <div key={dash.id} className="dashboard-card">
            <div>
              <span className="dept-tag">{dash.department}</span>
              <h3>{dash.title}</h3>
              <p>{dash.description}</p>
            </div>
            <a href={dash.url} target="_blank" rel="noopener noreferrer" className="launch-btn">
              Launch Dashboard →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}